import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './ServicePage.css';
import './GetQuote.css';

const GetQuote = () => {
  const navigate = useNavigate();
  
  const services = [
    { id: 'hardware', name: 'Hardware Installation', icon: '\u{1F4BB}\u{FE0E}', description: 'Professional hardware setup and configuration' },
    { id: 'network', name: 'Network Setup', icon: '🌐', description: 'Complete network infrastructure solutions' },
    { id: 'maintenance', name: 'System Maintenance', icon: '🔧', description: 'Ongoing system maintenance and support' },
    { id: 'support', name: 'Technical Support', icon: '🎆', description: '8 X 6 technical support services' },
    { id: 'server', name: 'Server Management', icon: '📊', description: 'Comprehensive server management solutions' },
    { id: 'recovery', name: 'Data Recovery', icon: '💾', description: 'Professional data recovery services' },
    { id: 'security', name: 'Security Solutions', icon: '🔒', description: 'Advanced cybersecurity protection' },
    { id: 'cloud', name: 'Cloud Services', icon: '☁️', description: 'Modern cloud infrastructure solutions' }
  ];

  const [selectedServices, setSelectedServices] = useState([]);

  const handleServiceToggle = (serviceId, serviceName) => {
    setSelectedServices(prev => {
      if (prev.some(service => service.id === serviceId)) {
        // Remove service if already selected
        return prev.filter(service => service.id !== serviceId);
      } else {
        // Add service if not selected
        return [...prev, { id: serviceId, name: serviceName }];
      }
    });
  };

  const handleGetQuote = () => {
    if (selectedServices.length === 0) {
      alert('Please select at least one service to get a quote.');
      return;
    }
    
    // Store selected services in sessionStorage to pass to contact page
    sessionStorage.setItem('selectedServices', JSON.stringify(selectedServices));
    navigate('/contact');
  };

  const isServiceSelected = (serviceId) => {
    return selectedServices.some(service => service.id === serviceId);
  };

  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <div className="hero-content">
            <h1 className="service-title">Get Your Custom Quote</h1>
            <p className="service-description">
              Tell us about your IT needs and get a personalized quote 
              tailored to your business requirements.
            </p>
          </div>
        </div>
      </div>

      <div className="service-content">
        <div className="container">
          <div className="quote-content">
            <div className="quote-intro">
              <h2>Choose Your Services</h2>
              <p>Select the services you're interested in, and our experts will provide you with a detailed quote.</p>
            </div>

            <div className="services-grid">
              {services.map((service, index) => (
                <div 
                  key={service.id} 
                  className={`quote-service-card ${isServiceSelected(service.id) ? 'selected' : ''}`}
                >
                  <div className="service-icon-large">{service.icon}</div>
                  <h3>{service.name}</h3>
                  <p>{service.description}</p>
                  <div className="service-actions">
                    <input 
                      type="checkbox" 
                      id={`service-${service.id}`} 
                      className="service-checkbox"
                      checked={isServiceSelected(service.id)}
                      onChange={() => handleServiceToggle(service.id, service.name)}
                    />
                    <label htmlFor={`service-${service.id}`} className="checkbox-label">
                      {isServiceSelected(service.id) ? 'Included in Quote ✓' : 'Include in Quote'}
                    </label>
                  </div>
                </div>
              ))}
            </div>

            {selectedServices.length > 0 && (
              <div className="selected-services-summary">
                <h3>Selected Services ({selectedServices.length})</h3>
                <div className="selected-services-list">
                  {selectedServices.map((service) => (
                    <div key={service.id} className="selected-service-item">
                      <span className="service-name">{service.name}</span>
                      <button 
                        className="remove-service-btn"
                        onClick={() => handleServiceToggle(service.id, service.name)}
                        title="Remove from quote"
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            )}

            <div className="quote-cta">
              <div className="cta-content">
                <h2>Ready to Get Started?</h2>
                <p>
                  {selectedServices.length > 0 
                    ? `You've selected ${selectedServices.length} service${selectedServices.length > 1 ? 's' : ''}. Our team will provide you with a detailed quote for your selected services.`
                    : 'Our team of experts is ready to discuss your requirements and provide you with a detailed, personalized quote.'
                  }
                </p>
                <div className="cta-buttons">
                  <button 
                    onClick={handleGetQuote}
                    className="btn btn-primary btn-large"
                    disabled={selectedServices.length === 0}
                  >
                    Get Detailed Quote
                    {selectedServices.length > 0 && ` (${selectedServices.length} services)`}
                  </button>
  
                  <a href="tel:+913335531279" className="btn btn-secondary btn-large">
                    Call Now: +91 (33) 35531279
                  </a>
                </div>
                <div className="cta-features">
                  <div className="cta-feature">
                    <span className="feature-icon">✓</span>
                    <span>Free Consultation</span>
                  </div>
                  <div className="cta-feature">
                    <span className="feature-icon">✓</span>
                    <span>24-48 Hour Response</span>
                  </div>
                  <div className="cta-feature">
                    <span className="feature-icon">✓</span>
                    <span>No Obligation Quote</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default GetQuote;
